import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  {
    num: '01',
    title: 'Discovery Call',
    desc: 'We review your current setup — how assets are tracked, how support requests come in, what tools exist, and where the gaps are.',
  },
  {
    num: '02',
    title: 'System Design',
    desc: 'We design the JSM environment: asset schema, request types, queues, SLAs, automations, and the portal your team will use.',
  },
  {
    num: '03',
    title: 'Build & Go-Live',
    desc: 'We build it, migrate your existing data, test everything, and get your team live — typically within 4–6 weeks of kickoff.',
  },
  {
    num: '04',
    title: 'Retainer Support',
    desc: 'We stay on as your JSM admin. Changes, expansions, and new workflows are handled on retainer — no new project required.',
  },
];

const HomeProcess = () => (
  <section id="process" className="py-24" style={{ background: '#f0fdf4' }}>
    <div className="max-w-5xl mx-auto px-8 lg:px-16">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#16a34a' }}>Process</p>
        <h2 className="text-3xl md:text-4xl font-bold mb-3" style={{ color: '#052e16' }}>Live in 4–6 weeks. Supported from day one.</h2>
        <p className="text-sm max-w-xl leading-relaxed" style={{ color: '#166534' }}>
          A defined build sequence followed by an ongoing retainer. You get a working system fast — and a partner who keeps it working.
        </p>
      </motion.div>
      <div className="grid md:grid-cols-4 gap-5">
        {steps.map((s, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ delay: i * 0.08 }}
            className="p-6 rounded-xl border" style={{ background: '#ffffff', borderColor: '#bbf7d0' }}>
            <div className="text-3xl font-bold mb-3" style={{ color: '#bbf7d0' }}>{s.num}</div>
            <h3 className="text-base font-bold mb-2" style={{ color: '#052e16' }}>{s.title}</h3>
            <p className="text-sm leading-relaxed" style={{ color: '#166534' }}>{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default HomeProcess;